import request from '@/utils/request'

/**
 * 获取用户列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getUsers = (params) => {
  return request({
    url: '/api/users',
    method: 'get',
    params
  })
}

/**
 * 获取可指派人员列表（派工下拉）
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getAssignableUsers = (params) => {
  return request({
    url: '/api/users/assignable',
    method: 'get',
    params
  })
}

/**
 * 获取管理者列表
 * @returns {Promise}
 */
export const getManagers = () => {
  return request({
    url: '/api/users/managers',
    method: 'get'
  })
}

/**
 * 获取单个用户详情
 * @param {number} userId - 用户ID
 * @returns {Promise}
 */
export const getUser = (userId) => {
  return request({
    url: `/api/users/${userId}`,
    method: 'get'
  })
}

/**
 * 创建新用户
 * @param {Object} userData - 用户数据
 * @returns {Promise}
 */
export const createUser = (userData) => {
  return request({
    url: '/api/users',
    method: 'post',
    data: userData
  })
}

/**
 * 更新用户信息
 * @param {number} userId - 用户ID
 * @param {Object} userData - 更新的用户数据
 * @returns {Promise}
 */
export const updateUser = (userId, userData) => {
  return request({
    url: `/api/users/${userId}`,
    method: 'put',
    data: userData
  })
}

/**
 * 删除用户（软删除，设置为非激活状态）
 * @param {number} userId - 用户ID
 * @returns {Promise}
 */
export const deleteUser = (userId) => {
  return request({
    url: `/api/users/${userId}`,
    method: 'delete'
  })
}

/**
 * 管理员重置用户密码
 * @param {number} userId - 用户ID
 * @param {Object} payload - { new_password, must_change_password }
 * @returns {Promise}
 */
export const resetUserPassword = (userId, payload) => {
  return request({
    url: `/api/users/${userId}/reset-password`,
    method: 'post',
    data: payload
  })
}

/**
 * 获取用户登录会话
 * @param {number} userId
 * @param {Object} params
 */
export const getUserLoginSessions = (userId, params) => {
  return request({
    url: `/api/users/${userId}/login-sessions`,
    method: 'get',
    params
  })
}

/**
 * 下线用户登录会话
 * @param {number} userId
 * @param {Object} payload - { session_id? | device_type?, reason? }
 */
export const offlineUserLoginSessions = (userId, payload) => {
  return request({
    url: `/api/users/${userId}/login-sessions/offline`,
    method: 'post',
    data: payload
  })
}

/**
 * 管理员在线用户概览
 */
export const getOnlineUsersOverview = () => {
  return request({
    url: '/api/users/online-overview',
    method: 'get'
  })
}
